import type { NavigateFunction } from 'react-router-dom'

/**
 * Send the visitor to the homepage emergency form — the single booking funnel
 * since the plumber-specific direct-booking flow was retired (2026-08). Mirrors
 * the Navbar's "Emergency Call-out" behaviour: scroll to the form and focus the
 * postcode input, navigating home first when needed.
 */
export function goToEmergencyForm(navigate: NavigateFunction): void {
  const focus = () => {
    document.getElementById('emergency-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    setTimeout(() => document.getElementById('postcode-input')?.focus(), 400)
  }
  if (window.location.pathname === '/') {
    focus()
  } else {
    navigate('/')
    setTimeout(focus, 100)
  }
}
